import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=ef3c1dee&scoped=true"
import script from "./productEdit.vue?vue&type=script&lang=js"
export * from "./productEdit.vue?vue&type=script&lang=js"
import style0 from "./productEdit.vue?vue&type=style&index=0&id=ef3c1dee&prod&lang=scss"
import style1 from "./productEdit.vue?vue&type=style&index=1&id=ef3c1dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3c1dee",
  null
  
)

export default component.exports